"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _caretDown = _interopRequireDefault(require("@spothero/icons/caret-down"));
var _caretUp = _interopRequireDefault(require("@spothero/icons/caret-up"));
var _TableHeadingPropTypes = _interopRequireDefault(require("./TableHeadingPropTypes"));
var _TableSortType = _interopRequireDefault(require("./TableSortType"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  ASC,
  DESC
} = _TableSortType.default;
class TableHeading extends _react.Component {
  _onSortToggleClick = () => {
    const {
      dataKey,
      sortOrder,
      onSortClick
    } = this.props;
    onSortClick({
      dataKey,
      sortOrder: !sortOrder ? ASC : sortOrder === ASC ? DESC : ASC
    });
  };
  render() {
    const {
      className,
      label,
      dataKey,
      sortOrder,
      isSortable
    } = this.props;
    const hasActiveSort = isSortable && sortOrder;
    const sortOrderClass = hasActiveSort ? `TableHeading-sort-${sortOrder.toLowerCase()}` : '';
    const classes = (0, _classnames.default)('TableHeading', {
      'TableHeading-sortable': isSortable
    }, {
      'TableHeading-sort-active': hasActiveSort
    }, sortOrderClass, className, dataKey);
    const headingProps = {
      className: classes
    };
    const Icon = sortOrder === ASC ? _caretUp.default : _caretDown.default;
    if (isSortable) {
      headingProps.onClick = this._onSortToggleClick;
    }
    return /*#__PURE__*/_react.default.createElement("th", headingProps, /*#__PURE__*/_react.default.createElement("div", {
      className: "TableHeading-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "TableHeading-label"
    }, label), isSortable && sortOrder && /*#__PURE__*/_react.default.createElement("div", {
      className: "TableHeading-sort"
    }, /*#__PURE__*/_react.default.createElement(Icon, {
      className: "TableHeading-sort-icon"
    }))));
  }
}
exports.default = TableHeading;